import { useState } from 'react';
import { BordOneToneIcon } from 'components/NudosComponents';
import { STOCK_METRICS_ITEM_TITLE_STYLE } from '../constants';
import ListOfReservedStocks from '../ListOfReservedStocks/ListOfReservedStocks';
import { IReservedStockInfo } from 'types/stockOrders';

import './StockMetrics.scss';

interface IStockMetrics {
  currentStockCount: number;
  stockAvailableReservationCount: number;
  reservedStockCount: number;
  reservedStockInfo: IReservedStockInfo;
  unitsCount: number;
}

const StockMetrics = ({
  currentStockCount,
  stockAvailableReservationCount,
  reservedStockCount,
  reservedStockInfo,
  unitsCount
}: IStockMetrics) => {
  const isStockAvailableReservationCountIsEmpty = stockAvailableReservationCount === 0;
  const isStockAvailableReservationCountIsNotEmpty = stockAvailableReservationCount > 0;
  const isStockAvailableReservationCountIsLimited = stockAvailableReservationCount < unitsCount;
  const isReservedStockCountIsEmpty = reservedStockCount === 0;

  const [openListOfReservedStocks, setOpenListOfReservedStocks] = useState(false);

  const renderStockMetricsItemTitleStyle = () => {
    if (isStockAvailableReservationCountIsEmpty) {
      return STOCK_METRICS_ITEM_TITLE_STYLE.LIMITED;
    }
    if (isStockAvailableReservationCountIsNotEmpty && !isStockAvailableReservationCountIsLimited) {
      return STOCK_METRICS_ITEM_TITLE_STYLE.NOT_EMPTY;
    }
    if (isStockAvailableReservationCountIsLimited) {
      return STOCK_METRICS_ITEM_TITLE_STYLE.LIMITED;
    }

    return STOCK_METRICS_ITEM_TITLE_STYLE.EMPTY;
  };

  const handleOpenListOfReservedStocks = () => {
    if (isReservedStockCountIsEmpty) return;
    setOpenListOfReservedStocks(!openListOfReservedStocks);
  };

  return (
    <div className="stockMetrics">
      <div className="stockMetricsTitle">Stock</div>
      <div className="stockMetricsContainer">
        <div className="stockMetricsItem">
          <div className="stockMetricsItemValue">{currentStockCount}</div>
          <div className="stockMetricsItemTitle">Stock actual</div>
        </div>
        <div className="dividerStyle" />
        <div className="stockMetricsItem">
          <div className={`stockMetricsItemValue ${renderStockMetricsItemTitleStyle()}`}>
            {stockAvailableReservationCount}
          </div>
          <div className={`stockMetricsItemTitle ${renderStockMetricsItemTitleStyle()}`}>Disponibles por reservar</div>
        </div>
        <div className="dividerStyle" />
        <div className="relative">
          <div className="stockMetricsItem" onClick={handleOpenListOfReservedStocks}>
            <div className="stockMetricsItemValue">{reservedStockCount}</div>
            <div className="stockMetricsItemTitleContainer">
              <div className="stockMetricsItemTitle">Stock reservado</div>
              <BordOneToneIcon variant="arrowHeadDown" standardSize={16} />
            </div>
          </div>
          {openListOfReservedStocks && <ListOfReservedStocks reservedStockInfo={reservedStockInfo} />}
        </div>
      </div>
    </div>
  );
};

export default StockMetrics;
